import { render } from "./FormFacet.vue?vue&type=template&id=063c51d3&ts=true"
import script from "./FormFacet.vue?vue&type=script&lang=ts"
export * from "./FormFacet.vue?vue&type=script&lang=ts"

import "./FormFacet.vue?vue&type=style&index=0&id=063c51d3&lang=scss"

import exportComponent from "/home/runner/work/hekate/hekate/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__